import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { OTPApi } from '../../../apis/OTPApi/OTPApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';
import { IOTP } from '../OTP';

export interface IDelegateOTPVariables {
    id: number;
    delegatedToHcpId: number;
}

export function useDelegateOTPForValidation(patientId?: number) {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation<IOTP, AppMedError, IDelegateOTPVariables>({
        mutationKey: [QueryKeys.otp, 'delegate'],
        mutationFn: async ({ id, delegatedToHcpId }: IDelegateOTPVariables) => {
            return await OTPApi.delegateOTPForValidation(id, delegatedToHcpId);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.otp] });
            if (patientId)
                queryClient.invalidateQueries({ queryKey: [QueryKeys.otpByPatient, patientId] });

            notifications.show({
                title: t('otp.notifications.delegateSuccess.title'),
                message: t('otp.notifications.delegateSuccess.message'),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('otp.notifications.delegateError.title'),
                message: error?.message || t('otp.notifications.delegateError.message'),
                color: 'red',
            });
        },
    });
}
